import {Color, Group, AnimationClip, AnimationMixer, LoopRepeat, AnimationAction, LoopPingPong} from "three";
import { JsonUtils, SceneConfiguration } from "threngine";
import { Services } from "threngine/dist/types/src/entry/engine/engine";


export class SceneGenerator {
    
    private _services:Services;
    private _blueprint:SceneConfiguration;

    constructor(services:Services) {
        this._services = services;
        //this.testAnimation();
    }
    
    loadScene = (o?:{options?:any, cameras?:any}):Promise<AnimationAction[]> => new Promise(resolve => {
        const scene = JsonUtils.deepCopy(this._blueprint);
        return this._services.scene.loadScene(scene).then(() => {
            
            //FIXME?: set background color here
            this._services.render.scene.background = new Color(255,255,255);

            const animation = this.animationHack();
            resolve(animation);
        });
    })

    setBlueprint = (blueprint:SceneConfiguration) => {
        this._blueprint = blueprint;
        //console.log("__ALL VISIBILITY GROUP: ", this._blueprint.visibility_groups);
    }

    animationHack = () => {
        const animationClips = [];
        // console.log("CHILD: ", this._services.render.scene.children)
        const filtered = this._services.render.scene.children.filter(c => {
            return (c as any).hackimations != undefined;
        })

        const animation = (filtered[0] as any).hackimations[0];


        const mixer1 = new AnimationMixer(this._services.render.scene.getObjectByName("main"));
        const mixer2 = new AnimationMixer(this._services.render.scene.getObjectByName("main"));
        this._services.render.onBeforeRender.subscribe(delta => {
          mixer1.update(0.05);
          mixer2.update(0.05);
          return Promise.resolve();
        });

        const deckelTracks = animation.tracks.filter((v:any,k:number)=>{return k == 0});
        const schrankTracks = animation.tracks.filter((v:any,k:number)=>{return k > 0});
        // console.log(deckelTracks, schrankTracks)
        let schrankAnim = Object.assign({}, animation);
        schrankAnim.tracks = deckelTracks;
        animationClips.push(mixer1.clipAction(schrankAnim));
        let deckelAnim = Object.assign({}, animation);
        deckelAnim.tracks = schrankTracks;
        animationClips.push(mixer2.clipAction(deckelAnim));
        return animationClips;
    }

    getAllGroupOfCurrentScene = ():Promise<Group[]> => {
        return new Promise((res, rej) => {
            let meshes:any[] = [];
            this._services.render.scene.traverse(o => {
                if (o.type == "Group"){
                    meshes.push((o));
                }
                else if (o.name === "Windfang" || o.name === "Windfang_XL"){
                    meshes.push((o));
                }
                    
            })
            return res(meshes);
        });
    }
}